/* eslint-disable @angular-eslint/no-output-on-prefix */
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';
import { DocumentInfo, DocumentState } from './document-info.model';
import { DocumentRepository } from '../../client/repositories/document/document.repository';
import { ToastService } from '../../shared/foundation/toast/toast.service';
import { TranslationMessagesPipe } from '../../shared/pipes/translation-msg.pipe';

@Component({
  selector: 'app-upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.scss'],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective,
    },
  ],
})
export class UploadComponent implements OnInit {
  @Input() controlName?: string;
  @Input() update = false;

  @Output() onChange: EventEmitter<DocumentInfo[]> = new EventEmitter<
    DocumentInfo[]
  >();

  @ViewChild('#fileDropRef') fileDropInput?: HTMLInputElement;

  public dragOver = false;
  files: DocumentInfo[] = [];
  uploadedFiles: DocumentInfo[] = [];

  constructor(
    private documentRepository: DocumentRepository,
    private toastService: ToastService,
    private msgPipe: TranslationMessagesPipe
  ) {}

  ngOnInit(): void {}

  onFileDropped(files: any): void {
    this.files = [];
    for (const file of files) {
      this.pushFile(file);
    }
    this.uploadDocuments();
  }

  fileBrowseHandler($event: any): void {
    this.files = [];
    const files = $event.target.files;
    for (const file of files) {
      this.pushFile(file);
    }
    this.uploadDocuments();
  }

  pushFile(file: any): void {
    if (!this.checkIfFileExist(file)) {
      this.files.push({
        file: file,
        documentId: null,
        state: DocumentState.Uploading,
      } as DocumentInfo);
    } else {
      this.toastService.showWarningToast(
        this.msgPipe.transformInstant('toasts.fileAlreadyUploaded'),
        1000
      );
    }
  }

  checkIfFileExist(file: any): boolean {
    const foundFile = this.uploadedFiles.find(
      (foundFile) =>
        foundFile.file &&
        foundFile.file?.name === file.name &&
        foundFile.file?.size === file.size
    );
    if (foundFile) {
      return true;
    }
    return false;
  }

  removeFile(file: DocumentInfo): void {
    if (file.state === DocumentState.Uploaded) {
      this.uploadedFiles.splice(this.uploadedFiles.indexOf(file), 1);
      this.onChange.emit(this.uploadedFiles);
    }
    this.files.splice(this.files.indexOf(file), 1);
  }

  uploadDocuments(): void {
    this.upload().then(() => {
      this.onChangeEmit();
    });
  }

  upload() {
    return new Promise<void>((resolve, reject) => {
      for (const file of this.files) {
        this.documentRepository.uploadDocument(file.file!).subscribe({
          next: (uid: any) => {
            file.uid = uid;
            file.state = DocumentState.Uploaded;
            this.uploadedFiles.push(file);
          },
          error: () => {
            this.toastService.showErrorToast(
              this.msgPipe.transformInstant('toasts.errorWhileUploading'),
              1000
            );
          },
        });
      }
      resolve();
    });
  }

  onChangeEmit() {
    this.onChange.emit(this.uploadedFiles);
  }

  public clearFileInputValue($event: any): void {
    $event.target.value = null;
  }
}
